var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 54,
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    transform: "matrix(-1 0 0 1 50 0)",
    fill: "url(#paint0_linear_422_1349)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_422_1349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4642 18.4634C20.9694 18.4634 18.1265 21.3063 18.1265 24.8011C18.1265 28.2958 20.9694 31.1388 24.4642 31.1388C27.9589 31.1388 30.8018 28.2958 30.8018 24.8011C30.8018 21.3063 27.9589 18.4634 24.4642 18.4634ZM24.4642 28.498C24.1726 28.498 23.936 28.2615 23.936 27.9699C23.936 27.6783 24.1726 27.4418 24.4642 27.4418C24.7557 27.4418 24.9923 27.6783 24.9923 27.9699C24.9923 28.2615 24.7557 28.498 24.4642 28.498ZM25.3002 25.1401C25.1132 25.2262 24.9923 25.4148 24.9923 25.6203V25.8574C24.9923 26.1489 24.7562 26.3855 24.4642 26.3855C24.1721 26.3855 23.936 26.1489 23.936 25.8574V25.6203C23.936 25.0039 24.2983 24.4388 24.8576 24.1805C25.3958 23.9328 25.7845 23.2753 25.7845 22.9525C25.7845 22.2248 25.1924 21.6322 24.4642 21.6322C23.7359 21.6322 23.1438 22.2248 23.1438 22.9525C23.1438 23.2441 22.9077 23.4807 22.6156 23.4807C22.3236 23.4807 22.0875 23.2441 22.0875 22.9525C22.0875 21.6423 23.1538 20.5759 24.4642 20.5759C25.7745 20.5759 26.8408 21.6423 26.8408 22.9525C26.8408 23.6661 26.2218 24.715 25.3002 25.1401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.848 9.76758H23.2094C15.9574 9.76758 10.0576 15.6674 10.0576 22.9193V23.4514V27.3989V30.0205C10.0576 30.4276 10.3876 30.7574 10.7946 30.7574H11.0893H11.9007V31.2764C11.9007 31.6835 12.2307 32.0133 12.6376 32.0133H13.975C15.2973 32.0133 16.3729 30.9377 16.3729 29.6155V23.8563C16.3729 22.534 15.2973 21.4584 13.975 21.4584H12.6376C12.2307 21.4584 11.9007 21.7883 11.9007 22.1953V22.7144H11.5367C11.6468 16.3698 16.8388 11.2415 23.2094 11.2415H25.848C32.2185 11.2415 37.4106 16.3698 37.5207 22.7146H37.1567V22.1953C37.1567 21.7883 36.8267 21.4584 36.4198 21.4584H35.0825C33.7603 21.4584 32.6846 22.534 32.6846 23.8563V29.6157C32.6846 30.938 33.7603 32.0136 35.0825 32.0136H36.4198C36.6239 32.0136 36.8086 31.9305 36.942 31.7964V33.387C36.942 35.5204 35.2063 37.2559 33.073 37.2559H28.6913C28.3987 36.5333 27.6907 36.0215 26.8643 36.0215H24.8745C23.7876 36.0215 22.9032 36.9059 22.9032 37.9929C22.9032 39.0798 23.7876 39.9642 24.8745 39.9642H26.8643C27.6907 39.9642 28.3987 39.4524 28.6913 38.7298H33.073C36.019 38.7298 38.4158 36.333 38.4158 33.387V30.7414C38.7494 30.6709 38.9998 30.3752 38.9998 30.0208V27.3992V23.4515V22.9195C38.9998 15.6674 33.1 9.76758 25.848 9.76758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_422_1349",
    x: 0.0576172,
    y: 3.76758,
    width: 48.9424,
    height: 50.1968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00326389 0 0 0 0 0.228538 0 0 0 0 0.391667 0 0 0 0.43 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_422_1349"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_422_1349",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_1349",
    x1: 20.5882,
    y1: 51.9608,
    x2: 39.2157,
    y2: 2.68404e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFE0",
    stopOpacity: 0.16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.99f565acb2c71d19334c4d75beaa45be.svg";
export { ForwardRef as ReactComponent };